import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'
import CarouselItem from './Carousel.item'
import { CarouselBase } from './Carousel.styles'

/**
 * The Carousel's component.
 */
const Carousel = props => {
  const { items, ...restProps } = props

  const theme = useTheme()

  return (
    <CarouselBase
      {...restProps}
      navButtonsProps={{
        style: {
          backgroundColor: theme.palette.brand.white,
          color: theme.palette.brand.black1
        }
      }}
      className="CarouselItem"
    >
      {items.map((item, i) => (
        <CarouselItem key={i} item={item} />
      ))}
    </CarouselBase>
  )
}

Carousel.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      item: PropTypes.node
    })
  ).isRequired
}

export default Carousel
